<template>
  <div id="faq-page">
    <!-- JUMBOTRON -->
    <div class="faq-jumbotron">
      <div class="faq-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base">
          <h1 class="mb-1 text-white">2배 빠른 영어! 말하면서 동시에 쓴다.</h1>
          <p class="text-white">토킹클래스는 매일 1시간씩 공부하는 프로그램으로 30분은 학습자 중심의 세스토플러로 INPUT 자기주도 학습을 하고 30분은 교사와 함께 점검 및 OUTPUT
            교재학습을 통해서 표현중심의 응용학습을 하게 됩니다.
          </p>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/5 lg:w-1/5">
        <vx-card>
            <div>
              <student-info/>
            </div>
            <vs-divider></vs-divider>
            <div class="mt-12">
              <banner-info />
            </div>
        </vx-card>
      </div>

    <div class="vx-col w-full md:w-3/5 lg:w-4/5 mt-12 md:mt-0">
      <div v-if="!bookList" class="mb-base">
        <vs-alert active="false" color="primary"  icon-pack="feather" icon="icon-star">
          학습설계가 되어 있지 않습니다. 
        </vs-alert>
      </div>
      <div v-if="bookList" class="mb-base">
        <vs-alert active="false" color="primary"  icon-pack="feather" icon="icon-star">
          현재 학습 중인 교재 입니다. [학습하기] 버튼을 클릭하여 학습을 진행해 주세요. 
        </vs-alert>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 lg:w-1/4 mb-base" :key="index" v-for="(book, index) in bookList" >
          <vx-card>
            <div slot="no-body">
              <img :src="'/uploads/book/' + book.bookCode + '.jpg'" alt="content-img" class="responsive card-img-top" @error="replaceByDefaultImg">
            </div>
            <h5 class="mb-2">{{ book.bookName }}</h5>
            <p class="text-grey mb-2">{{ book.courseName }} / {{ book.levelName }}</p>
            <p class="font-semibold">학습진척도 ({{book.progress}}%)</p>
            <div class="mb-4">
              <div class="flex justify-between">
                <small class="text-grey">0%</small>
                <small class="text-grey">100%</small>
              </div>
              <vs-progress :percent="book.progress" class="block mt-1 shadow-md"></vs-progress>
            </div>
            <div class="flex justify-between flex-wrap">
              <vs-button size="small" class="mt-4 mr-2 shadow-lg" type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC" @click="onStartStudy(book.bookCode)">학습하기</vs-button>
              <vs-button size="small" class="mt-4" type="border" color="#b9b9b9" @click="onStudyResult(book.bookCode)">결과보기</vs-button>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { fetchData } from '@/api/module'
import StudentInfo  from './StudentInfo'
import BannerInfo  from './BannerInfo'

export default {
  components: {
    StudentInfo,
    BannerInfo
  },
  data () {
    return {
      userInfo: null,
      bookList: []
    }
  },
  props: {
  },
  computed: {
  },
  methods: {
    replaceByDefaultImg (e) {
      e.target.src = '/uploads/book/img_404.jpg'
    },
    onStartStudy (bookCode) {
      this.$router.push(`/schedule?bookCode=${bookCode}`)
    },
    onStudyResult (bookCode) {
      this.$router.push(`/result?bookCode=${bookCode}`)
    },
    async loadBookList () {
      try { 
        const { data } = await fetchData(`/student/${  this.userInfo.userID  }/book`)
        this.bookList = data.list
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
    
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    this.loadBookList()
  },
  mounted () {
  }
}

</script>

<style lang="scss">
#faq-page {
    .faq-jumbotron-content {
        background-image: url('../assets/images/pages/faq.jpg');
        background-size: cover;
    }
    .faq-bg {
        background-color: #fff;
    }
}
</style>